document.addEventListener("DOMContentLoaded", function () {
    const voucherContainer = document.querySelector(".voucher-general--vertical-list");
    const voucherWidth = document.querySelector(".voucher-general")
    const prevButton = document.querySelector(".voucher-nav-button--prev");
    const nextButton = document.querySelector(".voucher-nav-button--next");

    function updateButtons() {
        const maxScrollLeft = voucherContainer.scrollWidth - voucherWidth.clientWidth;
        prevButton.disabled = voucherContainer.scrollLeft <= 0;
        nextButton.disabled = voucherContainer.scrollLeft + 300 >= maxScrollLeft; // Force to add 300px width to fulfill this logic else it will not disable
        console.log("This is", voucherContainer.scrollLeft)
    }

    function scrollVouchers(direction) {
        const scrollAmount = voucherWidth.clientWidth; // Scroll by the width of the visible container
        voucherContainer.scrollBy({
            left: direction === "next" ? scrollAmount : -scrollAmount,
            behavior: "smooth"
        });

        // Small delay to update button states after scrolling
        setTimeout(updateButtons, 300);
    }

    // Convx 849 P2: only wire the carousel when it exists. Unguarded, this threw on every PDP
    // without voucher nav buttons and aborted the handler before the copy-code buttons were bound.
    if (voucherContainer && voucherWidth && prevButton && nextButton) {
    // Event listeners for buttons
    nextButton.addEventListener("click", () => scrollVouchers("next"));
    prevButton.addEventListener("click", () => scrollVouchers("prev"));

    // Update button states on scroll
    voucherContainer.addEventListener("scroll", updateButtons);

    // Initial button state update
    updateButtons();
    }

    // Copy Code Section
    const copyGeneralCode = document.querySelectorAll(".general-copy-code");
    const codeElement = document.querySelectorAll(".general-copy-code .sr-only");
    // Show the "Link copied" notification
    const notification = document.querySelectorAll('.voucher-code-copied');

    copyGeneralCode.forEach((button, index) => {
      button.addEventListener('click', () => {
        const codeText = codeElement[index].textContent;
        const codeNotification = notification[index];

        codeNotification.style.opacity = 1;

        // Slow fade the notification after 5 seconds
        setInterval(function(){
          var opacity = codeNotification.style.opacity;
          if(opacity > 0){
            opacity -= 0.01;
            codeNotification.style.opacity = opacity;
          }
        }, 50);
    
        navigator.clipboard.writeText(codeText).then(() => {
            Swal.fire({
              title: `Copied`,
              icon: 'success',
              text: `Copied ${codeText} to clipboard.`,
            });
          }).catch(err => {
            console.error("Failed to copy text: " + err);
          });
      });
    });
  
});

